import { SendApplicationRequest } from '@interfaces/models';
import { httpClient } from '@api/interceptors';

export async function sendApplication(request: SendApplicationRequest): Promise<string> {
  return httpClient.post('help/send-application', { json: request }).text();
}
